import {utilModule} from '../module.js';
import displayErrorHtml from './displayError.html';
import angular from 'angular';

utilModule.directive('nsDisplayErrors', function() {
    return {
        restrict: 'A',
        scope: {
            error: '=nsDisplayErrors'
        },
        template: displayErrorHtml,
        link: function (scope) {
            //This function allows a user to show/hide error details with the keystroke Shift + N + U
            //default to hide.
            let map = {78:true,85:true};
            scope.showDetails=false;
            angular.element(document).bind('keydown',function (e) {
                if (e.keyCode in map) {
                    map[e.keyCode] = true;
                    if (map[78] && map[85]) {
                        scope.$apply(function() {
                            scope.showDetails = !scope.showDetails;
                        });
                    }
                }
            });
            angular.element(document).bind('keyup', function (e) {
                if (e.keyCode in map) {
                    map[e.keyCode] = false;
                }
            });
        }
    }
});
